import React from 'react';
import styles from './styles.module.scss';

import { ReactComponent as Checked } from '../../../assets/icons/icon-radio-checked.svg';
import { ReactComponent as Unchecked } from '../../../assets/icons/icon-radio-unchecked.svg';

const RadioSingle = ({ name, value, children, onChange }) => (
  <div className={styles.container}>
    <label className={styles.label}>
      <input type="radio" name={name} value={value} onChange={onChange} />
      <Checked />
      <Unchecked />
      <div className={styles.content}>{children}</div>
    </label>
  </div>
);

export default RadioSingle;
